import { render } from "./IconMap.vue?vue&type=template&id=e753c1b4"
import script from "./IconMap.vue?vue&type=script&lang=ts"
export * from "./IconMap.vue?vue&type=script&lang=ts"
script.render = render

export default script